import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJcb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_12659_80231)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M81.376 63.6201C81.376 69.4361 76.7245 74.172 71.0123 74.172H14.624V32.38C14.624 26.564 19.2754 21.8281 24.9877 21.8281H81.376V63.6201Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M63.0151 52.902H67.2993C67.4217 52.902 67.7073 52.8605 67.8297 52.8605C68.6458 52.6943 69.3394 51.9466 69.3394 50.908C69.3394 49.911 68.6458 49.1632 67.8297 48.9555C67.7073 48.9139 67.4625 48.9139 67.2993 48.9139H63.0151V52.902Z",
					fill: "url(#paint0_linear_12659_80231)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.8097 25.3593C62.7295 25.3593 59.3837 28.7242 59.3837 32.92V40.7716H69.8698C70.1146 40.7716 70.4002 40.7716 70.6042 40.8132C72.9707 40.9378 74.7252 42.1841 74.7252 44.3443C74.7252 46.0475 73.542 47.5015 71.3387 47.7923V47.8754C73.746 48.0416 75.5821 49.4125 75.5821 51.5312C75.5821 53.816 73.542 55.3116 70.849 55.3116H59.3429V70.6824H70.237C74.3172 70.6824 77.663 67.3174 77.663 63.1216V25.3593H66.8097Z",
					fill: "url(#paint1_linear_12659_80231)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.809 44.8428C68.809 43.8457 68.1153 43.1811 67.2993 43.0564C67.2177 43.0564 67.0137 43.0149 66.8913 43.0149H63.0151V46.6707H66.8913C67.0137 46.6707 67.2585 46.6707 67.2993 46.6291C68.1153 46.5045 68.809 45.8398 68.809 44.8428Z",
					fill: "url(#paint2_linear_12659_80231)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.7629 25.3593C21.6827 25.3593 18.3369 28.7242 18.3369 32.92V51.5727C20.4178 52.6113 22.5803 53.276 24.7429 53.276C27.3134 53.276 28.7006 51.6973 28.7006 49.5371V40.7301H35.0657V49.4956C35.0657 52.9021 32.9848 55.6854 25.9261 55.6854C21.6419 55.6854 18.2961 54.73 18.2961 54.73V70.6408H29.1903C33.2705 70.6408 36.6162 67.2759 36.6162 63.0801V25.3593H25.7629Z",
					fill: "url(#paint3_linear_12659_80231)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.2863 25.3593C42.2061 25.3593 38.8603 28.7242 38.8603 32.92V42.8072C40.7372 41.187 44.0014 40.1485 49.2648 40.3977C52.0802 40.5224 55.0995 41.3117 55.0995 41.3117V44.5105C53.5898 43.7212 51.7946 43.0149 49.4688 42.8488C45.4703 42.558 43.0629 44.552 43.0629 48.0416C43.0629 51.5727 45.4703 53.5668 49.4688 53.2344C51.7946 53.0683 53.5898 52.3205 55.0995 51.5727V54.7715C55.0995 54.7715 52.121 55.5608 49.2648 55.6855C44.0014 55.9347 40.7372 54.8962 38.8603 53.276V70.7239H49.7545C53.8347 70.7239 57.1804 67.359 57.1804 63.1632V25.3593H46.2863Z",
					fill: "url(#paint4_linear_12659_80231)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_12659_80231",
				x1: 59.3769,
				y1: 50.9129,
				x2: 77.7122,
				y2: 50.9129,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2285,
						stopColor: "#00873F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7433,
						stopColor: "#40A737"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#5CB531"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_12659_80231",
				x1: 59.3763,
				y1: 48.0027,
				x2: 77.7131,
				y2: 48.0027,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2285,
						stopColor: "#00873F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7433,
						stopColor: "#40A737"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#5CB531"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_12659_80231",
				x1: 59.3764,
				y1: 44.8376,
				x2: 77.7125,
				y2: 44.8376,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2285,
						stopColor: "#00873F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7433,
						stopColor: "#40A737"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#5CB531"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_12659_80231",
				x1: 18.3283,
				y1: 48.0027,
				x2: 36.9475,
				y2: 48.0027,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#1F286F" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4751,
						stopColor: "#004E94"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8261,
						stopColor: "#0066B1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#006FBC"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_12659_80231",
				x1: 38.7548,
				y1: 48.0027,
				x2: 56.8384,
				y2: 48.0027,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#6C2C2F" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1735,
						stopColor: "#882730"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5731,
						stopColor: "#BE1833"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8585,
						stopColor: "#DC0436"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#E60039"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_12659_80231",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 67.2,
					height: 52.8,
					fill: "white",
					transform: "translate(14.4 21.6001)"
				})
			})
		] })
	]
});
export default SvgJcb;
